import axios from "~/plugins/axios";

export default {
  search(customerId) {
    const url = "/web_api/v1/activity/search";

    return axios.get(url, {
      params: {
        subject_id: customerId,
      },
    })
      .then((response) => response.data);
  },
};
